import auth from '@/util/auth'

const Permission = {
  name:'Permission',
  functional: true,
  props:['code'],
  render(createElement, { props , scopedSlots }){
    let code = props.code
    if( code && auth.hasAuthority(code)){
      return scopedSlots ? scopedSlots.default() : null
    }else{
      return null
    }
  }
}

const directive = {
  inserted: (el, binding, vnode) => {
    let code = binding.value || binding.arg
    if( !code || !auth.hasAuthority(code) && false){
      el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
    }
  }
}

export default {
  install(Vue){
    Vue.component('slPermission' , Permission)
    Vue.directive('permission', directive)
  }
}

